// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__3sO-p","title":"SectionRulesMaybe_title__1GUQg","rules":"SectionRulesMaybe_rules__1Qh2L","info":"SectionRulesMaybe_info__1u54s"};